:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._container_2v35i_7 ._header_2v35i_7 {
  height: 42px;
  text-align: center;
  line-height: 40px;
  background-color: #f1f3f5;
  color: #3b4057;
  text-overflow: ellipsis;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd; }

._container_2v35i_7:first-of-type ._header_2v35i_7 {
  border-top: none; }

._thumbnailRemoveExit_2v35i_21 {
  opacity: 1; }

._thumbnailRemoveExitActive_2v35i_24 {
  opacity: 0;
  max-height: 0;
  transition: opacity 500ms, max-height 500ms ease-in-out; }
